import { useMemo, useState } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'

function useDebugMessage(
  messages: Record<string, string>,
  debugMessagesEnabled: boolean
) {
  const [showDevMessages, setShowDevMessages] = useState(false)

  useHotkeys(
    'mod+d',
    () => {
      setShowDevMessages((prev) => !prev)
    },
    { enabled: debugMessagesEnabled, preventDefault: true }
  )

  const transformedMessages = useMemo(() => {
    if (showDevMessages) {
      return Object.keys(messages).reduce(
        (acc, key) => ({
          ...acc,
          [key]: key,
        }),
        {}
      )
    }

    return messages
  }, [messages, showDevMessages])

  return { transformedMessages }
}

export default useDebugMessage
